import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BulkUploadExcelComponent } from './bulk-upload-excel/bulk-upload-excel.component';
import { BulkUploadEstampComponent } from './bulk-upload-estamp/bulk-upload-estamp.component';
import { OrderConfirmationDetailsComponent } from 'src/app/shared-components/order-confirmation-details/order-confirmation-details.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'excel-upload',
  },
  {
    path: 'excel-upload',
    component: BulkUploadExcelComponent,
  },
  {
    path: 'pdf-upload',
    component: BulkUploadEstampComponent,
  },
  {
    path: 'order-confirmation/:id',
    component: OrderConfirmationDetailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BulkUploadEstampRoutingModule {}
